module.exports = __webpack_public_path__ + "0d480b9959fab5f8d5d502c518f5ac4e.svg";